import React from 'react'

interface BasicLayoutProps {
  children: React.ReactNode;
  className?: string;
  leftPadding?: string;
  rightPadding?: string;
}

const Basiclayout: React.FC<BasicLayoutProps> = ({
  children,
  className = '',
  leftPadding = 'pl-20',
  rightPadding = 'pr-20'
}) => {
  return (
    <div className={`${leftPadding} ${rightPadding} ${className} font-work-sans max-lg:pl-10 max-lg:pr-10 max-md:pl-5 max-md:pr-5`}>
      {children}
    </div>
  )
}

export default Basiclayout